(function ($) {
    function setHeroBannerStyles() {
        var width = $(document).width();
        if (width >= 820) {
            $(".t03-screen-title").each(function () {
                $(this).find("div.screen-title-title").addClass("col-md-6");
                $(this).find("div.screen-title-title").addClass("hero-banner-topmargin");
            });
        }
        else {
            $('.t03-screen-title.t03-split-hero-banner').closest("div.col-12").addClass('layout-pad');
            $(".t03-screen-title").each(function () {
                $(this).find("div.screen-title-title").removeClass("hero-banner-topmargin");
                $(this).find("div.screen-title-title").removeClass("col-md-6");
                $(this).find("div.screen-title-title").addClass("col-12");
            });
        }
        $(".t03-screen-title").each(function () {
            var divbg = $(this).attr("data-backgroundcolor");
            var divtextcolor = $(this).attr("data-textcolor");
            var el = $(this).find('div.hero-banner-div');
            el.css('background', divbg);
            el.css('color', divtextcolor);
            $(this).find("div.screen-title-title").css('color', divtextcolor);
            $(this).find("div.screen-title-title").addClass("hero-banner-overlay");
        });
        $('.fullwidth-layout').each(function () {
            var el = $(this).find('div.col-2-layout');
            el.addClass("full-width-layout");
            var el2 = $(this).find('div.col-3-layout');
            el2.addClass("full-width-layout");
        });
        $('.fullwidth-layout-topmargin').parents("div.body-content ").addClass('fullwidth-toppad');
        $(".t03-screen-title .b05-button").each(function () {
            var btntextcolor = $(this).attr("data-textcolor");
            var btnbgcolor = $(this).attr("data-backgroundcolor");
            var btnbordercolor = $(this).attr("data-bordercolor");
            $(this).css('background', btnbgcolor);
            $(this).css('color', btntextcolor);
            $(this).css('border-color', btnbordercolor);
            $(this).addClass('btn-hero-banner ');
        });
        $('.fullwidth-layout').addClass('fullwidth-sidepad');
        $(".t03-screen-title .b04-link").each(function () {
            var anchor = $(this).find('a');
            var anchortextcolor = $(this).attr("data-textcolor");
            anchor.css('color', anchortextcolor);
        });
        $('.img-div').each(function () {
            var el = $(this).find('img');
            el.addClass("w-100");
        });
    }
    function setBannerTransparentStyles() {
        if (!$('.component').closest('.tab_component').length) {  // Check if the parent doesn't have the 'tab_component' class
            $('.component').each(function () {
                if (($(this).hasClass('t01-screen-title') == true) || ($(this).hasClass('t02-screen-title') == true) || ($(this).hasClass('t03-screen-title') == true) || ($(this).hasClass('t04-screen-title') == true)) {
                    if (($(this).find('.screen-title-copy').length > 0) && (($(this).find('.screen-title-copy').attr('data-opacity')) != undefined)) {
                        $(this).find('.screen-title-copy').css('opacity', 'unset');
                        var opacity1 = ((($(this).find('.screen-title-copy').attr('data-opacity')) != '') && (($(this).find('.screen-title-copy').attr('data-opacity')) != ' ')) ? (parseFloat($(this).find('.screen-title-copy').attr('data-opacity'))) : 1;
                        $(this).find('.screen-title-copy').css('background', 'rgba(255,255,255,' + opacity1 + ')');
                    }
                    else if (($(this).find('.screen-title-title').length > 0) && (($(this).find('.screen-title-title').attr('data-opacity')) != undefined)) {
                        $(this).find('.screen-title-title').css('opacity', 'unset');
                        var opacity2 = ((($(this).find('.screen-title-title').attr('data-opacity')) != '') && (($(this).find('.screen-title-title').attr('data-opacity')) != ' ')) ? (parseFloat($(this).find('.screen-title-title').attr('data-opacity'))) : 1;
                        $(this).find('.screen-title-title').css('background', 'rgba(255,255,255,' + opacity2 + ')');
                    }
                    else {
                        if (($(this).find('.screen-title-copy').length > 0) && (($(this).find('.screen-title-copy').attr('data-opacity')) == undefined)) {
                            $(this).find('.screen-title-copy').css('opacity', 'unset');
                            $(this).find('.screen-title-copy').css('background', 'rgba(255,255,255,1)');
                        }
                        if (($(this).find('.screen-title-title').length > 0) && (($(this).find('.screen-title-title').attr('data-opacity')) == undefined)) {
                            $(this).find('.screen-title-title').css('opacity', 'unset');
                            $(this).find('.screen-title-title').css('background', 'rgba(255,255,255,1)');
                        }
                    }
                }
            });
        }
    }
    $(document).ready(function () {
        setHeroBannerStyles();
        setBannerTransparentStyles();
    });
    $(window).resize(function () {
        setHeroBannerStyles();
    });
}(window.jQuery));

// Analytics for T04

analytics.eventConfig.push(
    {
        "target": ".component.t04-screen-title",
        "codeId": "t04",
        "events": [
            {
                "eventTarget": ".screen-title-copy a:not([href*=\\http])",
                "eventType": "click",
                "tags": {
                    "event": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "contact"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "navigation"
                        }
                    ],
                    "componentName": "screen title full overlay",
                    "componentId": "t04",
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "click to email"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "other media asset click"
                        },
                        {
                            "rule": "true",
                            "value": "screen title internal navigation click"
                        }
                    ],
                    "elementType": "screen title full overlay link",
                    "elementText": "",
                    "destinationUrl": "",
                    "fileName": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    //merged from chemicals
                    'event1': '',
                    'eventCategory': 'UX',
                    'eventAction': 'Clicked on Carousel Slide',
                    'eventLabel': "",
                    'slidePosition': "",
                    'imageSource': "",
                    'page_bu': "",
                   'page_language': "",
                    'page_title': "" ,
                    'page_type': "",
                    'pardot_cookie_id': "",
                    'sitecore_contact_id': ""
                    //merged from chemicals
                }
            },
            {
                "eventTarget": ".screen-title-copy a[href*=\\http]",
                "eventType": "click",
                "tags": {
                    "event": [
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "outbound"
                        }
                    ],
                    "componentName": "screen title full overlay",
                    "componentId": "t04",
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1",
                            "value": "pds download click"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                            "value": "sds download click"
                        },
                        {
                            "rule": "true",
                            "value": "outbound click"
                        }
                    ],
                    "elementType": "screen title full overlay link",
                    "elementText": "",
                    "destinationUrl": "",
                    "fileName": "",
                    "parentOrdinal": "",
                    //merged from chemicals
                    'event1': '',
                    'eventCategory': 'UX',
                    'eventAction': 'Clicked on Carousel Slide',
                    'eventLabel': "",
                    'slidePosition': "",
                    'imageSource': "",
                    'page_bu': "",
                   'page_language': "",
                    'page_title': "" ,
                    'page_type': "",
                    'pardot_cookie_id': "",
                    'sitecore_contact_id': ""
                    //merged from chemicals
                }
            }
        ]
    },
)